
export const formatDate = (value) => {
    if (!value) return "N/A";

    // Turn value into a string and drop "GMT..."
    const clean = String(value).replace(/\s*GMT.*/i, "").trim();
    // e.g. "Fri, 19 Dec 2025 10:39:23"

    const parts = clean.split(" ");
    if (parts.length < 2) return clean;

    // Last part is the time, everything before is the date text
    const time = parts.pop();              // "10:39:23"
    const prefix = parts.join(" ");        // "Fri, 19 Dec 2025"

    const t = time.split(":");
    if (t.length < 2) return `${prefix} ${time}`;

    let [h, m, s = "00"] = t;
    let hour = parseInt(h, 10);
    if (Number.isNaN(hour)) return `${prefix} ${time}`;

    const isPM = hour >= 12;
    if (hour === 0) hour = 12;        // 00 -> 12am
    else if (hour > 12) hour -= 12;   // 13–23 -> 1–11pm

    const hh = hour.toString().padStart(2, "0");
    const ampm = isPM ? "pm" : "am";

    return `${prefix} ${hh}:${m}:${s} ${ampm}`;
}

// round off to n decimal places
export const roundTo = (value, decimals = 0) => {
  if (decimals <= 0) return Math.round(value);
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};
